import React, { useEffect, useState } from 'react';
import { translate } from '../../../services/translate';
import { useQuery } from '@tanstack/react-query';
import { appAgentService } from '../../../services/central-api/app-agent';
import { useAuth } from '../../../context/Auth';
import { StyleProp, TextStyle, View, ViewStyle } from 'react-native';
import { useIsFocused } from '@react-navigation/native';
import FilterCheckboxList from '../Dispatch/FilterCheckboxList';
import MyAppText from '../../MyAppText';

interface Props {
    value: number[];
    setValue: React.Dispatch<React.SetStateAction<number[]>>;
    labelStyle?: StyleProp<TextStyle>;
    viewStyle?: StyleProp<ViewStyle>;
    emptyOption?: boolean;
}

export default function OccurrenceList({ value, setValue, labelStyle, emptyOption, viewStyle }: Props) {
    const { user: authenticatedUser } = useAuth();

    const [items, setItems] = useState<{ label: string; value: number; }[]>([]);

    const isFocused = useIsFocused();
    const queryResult = useQuery({
        queryKey: ['getSimplifiedOccurrences'],
        queryFn: () => appAgentService.getSimplifiedOccurrences(),
        enabled: !!authenticatedUser && isFocused,
    });

    const isEnabled = !!authenticatedUser;
    const isLoading = isEnabled && queryResult.isFetching;
    const { data } = queryResult;

    useEffect(() => {
        if (!authenticatedUser || !data) {
            return;
        }

        const options = data.map(occurrence => ({
            label: `${occurrence.id} - ${translate(occurrence.triggerType!)}`, value: occurrence.id!
        }));

        if (emptyOption) {
            options.unshift({ label: '', value: 0 });
        }
        setItems(options);
    }, [data, authenticatedUser]);

    return <View style={[{ flexDirection: 'column', gap: 12 }, viewStyle]}>
        <MyAppText style={labelStyle}>{translate('occurrence')}</MyAppText>
        <FilterCheckboxList items={items} value={value} setValue={setValue} isLoading={isLoading} />
    </View>;
}
